import React from 'react';
import { Layout } from 'fronton-react';
import { Banner, HeaderSection, RemoteCarouselWithBasket, RootLayout } from 'common/components';
import {
  NY_CLASSIC_PRODUCT_ID_LIST,
  NY_CLASSIC_SEE_MORE_LINK,
  NEW_YEAR_TREE_CDN_PATH,
  NEW_YEAR_TREE_ELEMENT_BLOCK,
  NEW_YEAR_TREE_PATH,
  NY_CLASSIC_IMAGE_LIST,
  NY_TREE_HEADER_IMAGE_LIST,
  NY_ROSE_GOLD_IMAGE_LIST,
  NY_ROSE_GOLD_PRODUCT_ID_LIST,
  NY_ROSE_GOLD_SEE_MORE_LINK,
  NY_FROSTY_NIGHT_IMAGE_LIST,
  NY_FROSTY_NIGHT_PRODUCT_ID_LIST,
  NY_FROSTY_NIGHT_SEE_MORE_LINK,
  NY_WINTER_TALE_IMAGE_LIST,
  NY_WINTER_TALE_SEE_MORE_LINK,
  NY_WINTER_TALE_PRODUCT_ID_LIST,
  NY_MODERN_STYLE_SEE_MORE_LINK,
  NY_MODERN_STYLE_IMAGE_LIST,
  NY_MODERN_STYLE_PRODUCT_ID_LIST,
} from './new-year-tree-constants';
import { NYTreeStyle } from './components';
import { nyTreeFirstStyle } from './new-year-tree-styles';

export const NewYearTree = () => (
  <RootLayout currentPage={NEW_YEAR_TREE_PATH}>
    <HeaderSection
      img={NY_TREE_HEADER_IMAGE_LIST}
      bgColor="#43131F"
      description="От&nbsp;дизайнеров Лемана&nbsp;ПРО"
      hasPattern={false}
      mediaType="image"
      title="Украшения для ели в&nbsp;разных стилях"
    />
    <Layout>
      <NYTreeStyle
        className={nyTreeFirstStyle}
        title="Ёлка в современном стиле"
        text="Встретьте Новый год в&nbsp;эстетике утонченного минимализма. Монохромные бежевые оттенки и&nbsp;чистые линии создают атмосферу спокойной роскоши и&nbsp;гармонии."
        imageList={NY_MODERN_STYLE_IMAGE_LIST}
        href={NY_MODERN_STYLE_SEE_MORE_LINK}
        linkTitle="Новогодний декор в классических тонах"
      />
    </Layout>
    <RemoteCarouselWithBasket
      elementBlock={NEW_YEAR_TREE_ELEMENT_BLOCK}
      productIdList={NY_MODERN_STYLE_PRODUCT_ID_LIST}
      remoteId="modernProductsCarousel"
      seeMoreLink={NY_MODERN_STYLE_SEE_MORE_LINK}
      showSeeMore
      title="Товары из этой коллекции"
    />
    <Layout>
      <NYTreeStyle
        title="Классика Нового года"
        text="Декор в&nbsp;традиционных тонах мгновенно наполнит ваш дом теплом и&nbsp;уютом. Благородная и&nbsp;торжественная ель станет местом притяжения для всей семьи в&nbsp;праздничные дни."
        imageList={NY_CLASSIC_IMAGE_LIST}
        href={NY_CLASSIC_SEE_MORE_LINK}
        linkTitle="Новогодний декор в классических тонах"
      />
    </Layout>
    <RemoteCarouselWithBasket
      elementBlock={NEW_YEAR_TREE_ELEMENT_BLOCK}
      productIdList={NY_CLASSIC_PRODUCT_ID_LIST}
      remoteId="classicProductsCarousel"
      seeMoreLink={NY_CLASSIC_SEE_MORE_LINK}
      showSeeMore
      title="Товары из этой коллекции"
    />
    <Layout>
      <NYTreeStyle
        title="Розовое золото"
        text="Нежный розовый цвет в&nbsp;сочетании с&nbsp;роскошным золотым придадут новогоднему торжеству особый шик. А&nbsp;если выбрать украшения в&nbsp;трендовом оттенке фуксии, ваша нарядная ель точно привлечёт к&nbsp;себе взгляды гостей!"
        imageList={NY_ROSE_GOLD_IMAGE_LIST}
        href={NY_ROSE_GOLD_SEE_MORE_LINK}
        linkTitle="Новогодний декор в розово-золотых тонах"
      />
    </Layout>
    <RemoteCarouselWithBasket
      elementBlock={NEW_YEAR_TREE_ELEMENT_BLOCK}
      productIdList={NY_ROSE_GOLD_PRODUCT_ID_LIST}
      remoteId="roseGoldProductsCarousel"
      seeMoreLink={NY_ROSE_GOLD_SEE_MORE_LINK}
      showSeeMore
      title="Товары из этой коллекции"
    />
    <Layout>
      <NYTreeStyle
        title="Морозная ночь"
        text="Будто снежная королева, новогодняя ель в&nbsp;сине-серебряных тонах станет воплощением морозной и&nbsp;сказочной зимней ночи. Сверкающая от&nbsp;звёзд и&nbsp;мерцающих снежинок, она наполнит ваш дом волшебством."
        imageList={NY_FROSTY_NIGHT_IMAGE_LIST}
        href={NY_FROSTY_NIGHT_SEE_MORE_LINK}
        linkTitle="Новогодний декор в сине-серебряных тонах"
      />
    </Layout>
    <RemoteCarouselWithBasket
      elementBlock={NEW_YEAR_TREE_ELEMENT_BLOCK}
      productIdList={NY_FROSTY_NIGHT_PRODUCT_ID_LIST}
      remoteId="frostyNightProductsCarousel"
      seeMoreLink={NY_FROSTY_NIGHT_SEE_MORE_LINK}
      showSeeMore
      title="Товары из этой коллекции"
    />
    <Layout>
      <Banner
        bgColor="#4C754E"
        elementBlock={`${NEW_YEAR_TREE_ELEMENT_BLOCK} / new-year-main`}
        content={{
          media: {
            alt: 'Празднования Нового года',
            srcD: `${NEW_YEAR_TREE_CDN_PATH}/banner/banner-d.png/banner-d.png`,
            srcT: `${NEW_YEAR_TREE_CDN_PATH}/banner/banner-t.png/banner-t.png`,
            src: `${NEW_YEAR_TREE_CDN_PATH}/banner/banner-m.png/banner-m.png`,
          },
          title: 'Всё для подготовки к\u00A0новому году',
          text: 'Декор, освещение и\u00A0подарки по\u00A0низким ценам',
        }}
        link={{
          href: '/promo/novyy-god/',
          title: 'Новогодние товары',
        }}
        promotion={{
          name: NEW_YEAR_TREE_ELEMENT_BLOCK,
          creative: 'Всё для подготовки к новому году',
          position: '1',
        }}
      />
      <NYTreeStyle
        title="Зимняя сказка"
        text="Снежная зима приближает волшебное ощущение праздника. Воздушные и&nbsp;лёгкие украшения белого цвета&nbsp;&mdash; прекрасный праздничный наряд для вашей новогодней красавицы!"
        imageList={NY_WINTER_TALE_IMAGE_LIST}
        href={NY_WINTER_TALE_SEE_MORE_LINK}
        linkTitle="Ёлка в светлых цветах"
      />
    </Layout>
    <RemoteCarouselWithBasket
      elementBlock={NEW_YEAR_TREE_ELEMENT_BLOCK}
      productIdList={NY_WINTER_TALE_PRODUCT_ID_LIST}
      remoteId="winterTaleProductsCarousel"
      seeMoreLink={NY_WINTER_TALE_SEE_MORE_LINK}
      showSeeMore
      title="Товары из этой коллекции"
    />
  </RootLayout >
);
